var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Canvas"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Canvas",
    clipPath: "url(#clip-Canvas)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1-2",
    "data-name": 1,
    transform: "translate(-28.582 -30.72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M74.76,30.889a1.225,1.225,0,0,0-.624-.169,1.3,1.3,0,0,0-1.3,1.285l0,10.949a2.342,2.342,0,0,0,1.172,2.008l36.128,21.055v42.112a2.316,2.316,0,0,0,1.141,2.009l9.4,5.475a1.267,1.267,0,0,0,1.735-.468,1.235,1.235,0,0,0,.167-.637V60.538a3.091,3.091,0,0,0-1.52-2.668Z",
    fill: "#df1c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M83.337,93.852a1.21,1.21,0,0,1,.463.463,1.287,1.287,0,0,1-.465,1.756l-8.948,5.213a3,3,0,0,1-3.053,0L61.99,95.846a3.087,3.087,0,0,1-1.518-2.666V82.3a3.083,3.083,0,0,1,1.539-2.677l8.941-5.207a1.25,1.25,0,0,1,1.888,1.112V87.768Z",
    fill: "#df1c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M86.393,95.622a2.3,2.3,0,0,1-1.147-2v-13.1l-11.24-6.552a2.33,2.33,0,0,1-1.167-2V61.02A1.292,1.292,0,0,1,74.764,59.9L96.184,72.388a3.077,3.077,0,0,1,1.508,2.659V100a1.289,1.289,0,0,1-.171.635,1.267,1.267,0,0,1-1.734.471Z",
    fill: "#df1c4c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M70.962,45.392a1.258,1.258,0,0,1,1.878,1.124V57.464a2.3,2.3,0,0,1-1.121,2l-23.691,13.8v28.945L72.84,116.686,96.55,102.88a2.272,2.272,0,0,1,2.289,0l9.393,5.479a1.265,1.265,0,0,1,.465.468,1.291,1.291,0,0,1-.466,1.752L74.387,130.3a3.012,3.012,0,0,1-3.057,0L37.1,110.355a3.087,3.087,0,0,1-1.519-2.664v-39.9A3.083,3.083,0,0,1,37.1,65.129Z",
    fill: "#df1c4c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Color_Overlay",
    "data-name": "Color Overlay",
    d: "M42.747,99.581,8.519,79.636A3.088,3.088,0,0,1,7,76.972v-39.9A3.081,3.081,0,0,1,8.519,34.41L42.379,14.673A1.257,1.257,0,0,1,44.258,15.8V26.744a2.3,2.3,0,0,1-1.121,2l-23.691,13.8V71.492L44.258,85.966,67.968,72.16a2.274,2.274,0,0,1,2.29,0l9.393,5.479a1.266,1.266,0,0,1,.464.468,1.291,1.291,0,0,1-.465,1.752L45.8,99.585a3,3,0,0,1-1.522.415A3.032,3.032,0,0,1,42.747,99.581ZM92.1,84.893l-9.4-5.475a2.315,2.315,0,0,1-1.14-2.01V35.3L45.427,14.243a2.343,2.343,0,0,1-1.172-2.008l0-10.949A1.3,1.3,0,0,1,45.553,0a1.223,1.223,0,0,1,.625.169L92.48,27.15A3.09,3.09,0,0,1,94,29.818v53.97a1.242,1.242,0,0,1-.167.637,1.266,1.266,0,0,1-1.735.468ZM42.752,70.564l-9.345-5.438A3.089,3.089,0,0,1,31.89,62.46V51.583a3.083,3.083,0,0,1,1.539-2.677L42.369,43.7a1.25,1.25,0,0,1,1.889,1.111V57.048l10.5,6.084a1.209,1.209,0,0,1,.463.463,1.288,1.288,0,0,1-.465,1.757L45.8,70.564a2.967,2.967,0,0,1-1.519.418A3.039,3.039,0,0,1,42.752,70.564ZM67.2,70.385,57.811,64.9a2.3,2.3,0,0,1-1.147-2V49.8L45.425,43.252a2.328,2.328,0,0,1-1.166-2V30.3a1.292,1.292,0,0,1,1.923-1.116L67.6,41.668a3.079,3.079,0,0,1,1.507,2.66V69.279a1.3,1.3,0,0,1-.172.635,1.266,1.266,0,0,1-1.734.471Z",
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtole);
export default __webpack_public_path__ + "static/media/extole.6fc225efa775b1fddddb36d042a9512a.svg";
export { ForwardRef as ReactComponent };